import { IoIosArrowBack } from "react-icons/io";
// import H_Nav from '../home/H_Nav';
import "../style/login/Login.scss";
import icon1 from "../../assets/login/google.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";

const Login = ({mode}) => {
  let Lcw = 25;
  if(mode===2){
    Lcw = 100;
  }
  else{
    Lcw = 25;
  }
  const changeLabelPosition = () => {
    let label = document.querySelector(".Login-container-username-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Login-container-username-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Login-container-username-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Login-container-username-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const changeLabelPosition2 = () => {
    let label = document.querySelector(".Login-container-password-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Login-container-password-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault2 = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Login-container-password-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Login-container-password-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const dispatch = useDispatch();
  const { dashNav } = bindActionCreators(actionCreators, dispatch);

  const ShowNav = () => {
    dashNav();
  };
  
  return (
    <div className="Login">
      {/* <H_Nav/> */}
      <div style={{width:`${Lcw}%`}} className="Login-container">
        {(mode===1) && <div className="Login-container-back-btn-box">
          <IoIosArrowBack className="Login-container-back-btn-box-icon" />
          <Link to="/" className="Login-container-back-btn-box-text">
            بازگشت به صفحه اصلی
          </Link>
        </div>}
        <div className="Login-container-title">
          سلام <br />
          خوش برگشتی!
        </div>
        <div className="Login-container-username-box">
          <label
            className="Login-container-username-box-label"
            htmlFor="Login-container-username-box-input"
          >
            نام کاربری
          </label>
          <input
            type="text"
            name="Login-container-username-box-input"
            id="Login-container-username-box-input"
            onFocus={changeLabelPosition}
            onBlur={(e) => backToDefault(e)}
          />
        </div>
        <div className="Login-container-password-box">
          <label
            className="Login-container-password-box-label"
            htmlFor="Login-container-password-box-input"
          >
            رمز عبور
          </label>
          <input
            type="password"
            name="Login-container-password-box-input"
            id="Login-container-password-box-input"
            onFocus={changeLabelPosition2}
            onBlur={(e) => backToDefault2(e)}
          />
        </div>
        <div className="Login-container-remember-forget-box">
          <div className="Login-container-remember-forget-box-remember">
            <input type="checkbox" name="lcrfbr" id="lcrfbr" />
            <label htmlFor="lcrfbr">مرا به‌خاطر بسپار</label>
          </div>
          <div className="Login-container-remember-forget-box-forget-btn">
            رمز عبور خود را فراموش کردید؟
          </div>
        </div>
        <Link
          to="/dashboard"
          className="Login-container-enter-btn"
          onClick={ShowNav}
        >
          ورود
        </Link>
        <div className="Login-container-line-box">
          <div className="Login-container-line-box-item"></div>
          <div className="Login-container-line-box-text">یا</div>
          <div className="Login-container-line-box-item"></div>
        </div>
        <div className="Login-container-enter-btn-with-google">
          <img src={icon1} alt="google-logo" />
          <div className="Login-container-enter-btn-with-google-text">
            ورود با اکانت گوگل
          </div>
        </div>
        <div className="Login-container-create-account">
          <div className="Login-container-create-account-text">
            حساب کاربری ندارید؟
          </div>
          <div className="Login-container-create-account-btn">
            همین حالا بسازید
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
